export const authCashflowData = [
  { month: 'May', revenue: 158, expenses: 102, forecast: 155 },
  { month: 'Jun', revenue: 171, expenses: 108, forecast: 168 },
  { month: 'Jul', revenue: 165, expenses: 115, forecast: 172 },
  { month: 'Aug', revenue: 189, expenses: 118, forecast: 185 },
  { month: 'Sep', revenue: 204, expenses: 122, forecast: 198 },
  { month: 'Oct', revenue: 218, expenses: 128, forecast: 224 },
];

export const authAiInsights = [
  { id: '1', text: 'Revenue growth detected across core product lines.', type: 'positive' as const },
  { id: '2', text: 'GST compliance healthy — all branches on schedule.', type: 'positive' as const },
  { id: '3', text: 'Vendor anomaly identified in procurement ledger.', type: 'alert' as const },
  { id: '4', text: 'Cash runway improved by 12% vs last quarter.', type: 'neutral' as const },
];

export const authAiInsightStream = [
  { id: 's1', text: 'Analyzing financial variance…', type: 'neutral' as const, phase: 'thinking' as const },
  { id: 's2', text: 'Cashflow anomaly detected in vendor ledger.', type: 'alert' as const, phase: 'detect' as const },
  { id: 's3', text: 'Forecast updated successfully — Q4 runway +12%.', type: 'positive' as const, phase: 'complete' as const },
  { id: 's4', text: 'Reconciling GST filings across 3 branches…', type: 'neutral' as const, phase: 'thinking' as const },
  { id: 's5', text: 'Approval queue optimized — 2 items cleared.', type: 'positive' as const, phase: 'complete' as const },
];

export const authOperationsFeed = [
  { id: '1', action: 'Invoice reconciled · INV-2847', time: '2m ago' },
  { id: '2', action: 'Payroll completed for October', time: '14m ago' },
  { id: '3', action: 'GST filed · Hyderabad branch', time: '1h ago' },
  { id: '4', action: 'Approval completed · vendor payout', time: '2h ago' },
  { id: '5', action: 'AI recommendation generated', time: '3h ago' },
];

export const authHealthMetrics = [
  { label: 'Compliance', score: 94, color: '#16a34a' },
  { label: 'Financial', score: 87, color: '#2563eb' },
  { label: 'Operations', score: 82, color: '#4f46e5' },
  { label: 'AI confidence', score: 91, color: '#0d9488' },
];

export const workspacePreviews = {
  business: {
    title: 'Founder dashboard',
    metrics: ['P&L live', 'Cashflow +18%', '3 approvals'],
    feed: ['Cashflow graph active', 'GST on schedule', 'Vendor payout queued'],
  },
  ca: {
    title: 'Client operations',
    metrics: ['12 clients', '4 filings due', '98% compliance'],
    feed: ['Filing calendar synced', 'GSTR-3B draft ready', 'Client review pending'],
  },
} as const;

export const authPanelCopy: Record<
  string,
  { eyebrow: string; title: string; subtitle: string; stat: string }
> = {
  '/login': {
    eyebrow: 'Operational intelligence',
    title: 'Your finance OS is already running',
    subtitle:
      'Sign in to cashflow, GST compliance, approvals, and AI insights — unified for Indian businesses.',
    stat: '₹218L net · Oct',
  },
  '/register': {
    eyebrow: 'Workspace onboarding',
    title: 'Launch your command center in minutes',
    subtitle:
      'Create a secure workspace with live dashboards, AI variance detection, and GST-ready operations.',
    stat: '14.6 mo runway forecast',
  },
  '/forgot-password': {
    eyebrow: 'Account recovery',
    title: 'Secure access restoration',
    subtitle: 'We will send a protected link to reset your password and restore workspace access.',
    stat: 'Encrypted · SOC-ready',
  },
  '/reset-password': {
    eyebrow: 'Security update',
    title: 'Strengthen your workspace gate',
    subtitle: 'Choose a strong password to protect operational data and financial intelligence.',
    stat: '256-bit transit encryption',
  },
  '/verify-email': {
    eyebrow: 'Identity verification',
    title: 'Activate your finance workspace',
    subtitle: 'Confirm your email to unlock dashboards, AI insights, and compliance tooling.',
    stat: 'One-time secure code',
  },
};

export const defaultAuthPanelCopy = authPanelCopy['/login']!;
